var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"my-4"},[_vm._v(_vm._s(_vm.$t('SYSTEM_WELCOME_BACK')))]),_c('LoginForm')],1)}
var staticRenderFns = []

export { render, staticRenderFns }